/* Jackler quick-add (6.27). One page-singleton bottom sheet, mobile only -
   the desktop hover quick-add was dropped (Dan, 2026-08-12; the chip code
   lives in the build record if it is ever revived). Data comes from the
   vendor's per-card variants JSON; adds go through the card element's own
   addToCart so cart behavior stays canonical. */
(function () {
  'use strict';
  if (window.QuickAddSheet) return;

  var sheet, scrim, card, titleEl, msgEl;
  var colorLabelEl, colorsWrap, sizeLabelEl, pillsWrap;
  /* 6.91: the Print picker. Both refs stay hidden on every product whose
     card carries no data-print-index, i.e. the whole existing catalogue. */
  var printLabelEl, printsWrap;

  /* Sheet-level in-flight lock, shape { pill, timer }. While it is set no
     other pill (size or color) may act, and only the timer it owns may
     fire - an orphaned timer from an earlier add must never print into a
     later sheet. */
  var pending = null;

  /* Sheet state for the open card: { variants, current, sizeIndex, colorIndex } */
  var state = null;

  function clearPillState(pill) {
    if (!pill) return;
    delete pill.dataset.pending;
    pill.classList.remove('loading');
    pill.removeAttribute('aria-disabled');
  }

  function readCard(cardEl) {
    var sizesEl = cardEl && cardEl.querySelector('.product-card-sizes');
    var jsonEl = cardEl && cardEl.querySelector('.product-card-sizes--container [type="application/json"]');
    if (!sizesEl || !jsonEl) return null;
    var variants;
    try { variants = JSON.parse(jsonEl.textContent); } catch (e) { return null; }
    if (!variants.length) return null;
    var printIndex = sizesEl.dataset.printIndex;
    return {
      variants: variants,
      current: sizesEl.dataset.options.split(','),
      sizeIndex: parseInt(sizesEl.dataset.index, 10),
      printIndex: printIndex === undefined || printIndex === '' ? null : parseInt(printIndex, 10)
    };
  }

  function distinctValues(variants, index) {
    var vals = [];
    variants.forEach(function (v) {
      if (vals.indexOf(v.options[index]) === -1) vals.push(v.options[index]);
    });
    return vals;
  }

  /* First non-size option index carrying more than one value (Color on this
     store). null when the product has a single colorway. */
  function findColorIndex(data) {
    var count = data.variants[0].options.length;
    for (var i = 0; i < count; i++) {
      if (i === data.sizeIndex) continue;
      if (i === data.printIndex) continue;
      if (distinctValues(data.variants, i).length > 1) return i;
    }
    return null;
  }

  function variantFor(variants, options) {
    return variants.find(function (v) {
      return v.options.every(function (opt, i) { return options[i] === opt; });
    });
  }

  function colorHasStock(variants, colorIndex, value) {
    return variants.some(function (v) {
      return v.options[colorIndex] === value && v.available;
    });
  }

  /* ---------------- mobile bottom sheet ---------------- */

  function build() {
    scrim = document.createElement('div');
    scrim.className = 'quick-add-scrim';
    sheet = document.createElement('div');
    sheet.className = 'quick-add-sheet';
    sheet.setAttribute('role', 'dialog');
    sheet.setAttribute('aria-modal', 'true');
    sheet.setAttribute('aria-label', 'Quick add to cart');
    sheet.innerHTML =
      '<button type="button" class="quick-add-sheet__close side-panel-close" aria-label="Close">&times;</button>' +
      '<div class="quick-add-sheet__title"></div>' +
      '<div class="quick-add-sheet__label quick-add-sheet__label--color">Color</div>' +
      '<div class="quick-add-sheet__colors"></div>' +
      '<div class="quick-add-sheet__label quick-add-sheet__label--print">Print</div>' +
      '<div class="quick-add-sheet__colors quick-add-sheet__prints"></div>' +
      '<div class="quick-add-sheet__label quick-add-sheet__label--size">Size</div>' +
      '<div class="quick-add-sheet__pills"></div>' +
      '<div class="quick-add-sheet__msg" role="status"></div>';
    document.body.appendChild(scrim);
    document.body.appendChild(sheet);
    titleEl = sheet.querySelector('.quick-add-sheet__title');
    colorLabelEl = sheet.querySelector('.quick-add-sheet__label--color');
    colorsWrap = sheet.querySelector('.quick-add-sheet__colors:not(.quick-add-sheet__prints)');
    printLabelEl = sheet.querySelector('.quick-add-sheet__label--print');
    printsWrap = sheet.querySelector('.quick-add-sheet__prints');
    sizeLabelEl = sheet.querySelector('.quick-add-sheet__label--size');
    pillsWrap = sheet.querySelector('.quick-add-sheet__pills');
    msgEl = sheet.querySelector('.quick-add-sheet__msg');
    scrim.addEventListener('click', close);
    sheet.querySelector('.quick-add-sheet__close').addEventListener('click', close);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && sheet.classList.contains('active')) close();
    });
    document.addEventListener('cart:item-added', onAdded);
  }

  function renderColors() {
    if (state.colorIndex === null) {
      colorLabelEl.style.display = 'none';
      colorsWrap.style.display = 'none';
      sizeLabelEl.style.display = 'none';
      colorsWrap.innerHTML = '';
      return;
    }
    colorLabelEl.style.display = '';
    colorsWrap.style.display = '';
    sizeLabelEl.style.display = '';
    colorsWrap.innerHTML = '';
    distinctValues(state.variants, state.colorIndex).forEach(function (value) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'quick-add-sheet__color-pill';
      chip.textContent = value;
      if (value === state.current[state.colorIndex]) chip.classList.add('is-selected');
      if (!colorHasStock(state.variants, state.colorIndex, value)) {
        chip.classList.add('is-disabled');
        chip.disabled = true;
      } else {
        chip.addEventListener('click', function () {
          if (pending) return;
          state.current[state.colorIndex] = value;
          msgEl.textContent = '';
          renderColors();
          renderPrints();
          renderSizes();
        });
      }
      colorsWrap.appendChild(chip);
    });
  }

  /* 6.91: the third picker. Renders nothing at all unless the card told us
     where the Print option sits, so the sheet is byte-identical on every
     two-option product. Both Print values are offered; the add resolves
     against colour + size + print, so the right variant goes in the cart. */
  function renderPrints() {
    if (state.printIndex === null) {
      printLabelEl.style.display = 'none';
      printsWrap.style.display = 'none';
      printsWrap.innerHTML = '';
      return;
    }
    printLabelEl.style.display = '';
    printsWrap.style.display = '';
    sizeLabelEl.style.display = '';
    printsWrap.innerHTML = '';
    distinctValues(state.variants, state.printIndex).forEach(function (value) {
      var chip = document.createElement('button');
      chip.type = 'button';
      chip.className = 'quick-add-sheet__color-pill';
      chip.textContent = value;
      if (value === state.current[state.printIndex]) chip.classList.add('is-selected');
      if (!colorHasStock(state.variants, state.printIndex, value)) {
        chip.classList.add('is-disabled');
        chip.disabled = true;
      } else {
        chip.addEventListener('click', function () {
          if (pending) return;
          state.current[state.printIndex] = value;
          msgEl.textContent = '';
          renderPrints();
          renderSizes();
        });
      }
      printsWrap.appendChild(chip);
    });
  }

  function renderSizes() {
    pillsWrap.innerHTML = '';
    distinctValues(state.variants, state.sizeIndex).forEach(function (size) {
      var opts = state.current.slice();
      opts[state.sizeIndex] = size;
      var v = variantFor(state.variants, opts);
      var pill = document.createElement('button');
      pill.type = 'button';
      pill.className = 'quick-add-sheet__pill';
      pill.innerHTML = '<span>' + size + '</span><span class="loading-overlay"></span>';
      if (!v || !v.available) {
        pill.classList.add('is-disabled');
        pill.disabled = true;
      } else {
        pill.addEventListener('click', function () {
          /* One add at a time for the whole sheet, not just this pill. */
          if (pending) return;
          if (pill.classList.contains('added')) return;
          msgEl.textContent = '';
          /* The vendor's addToCart strips its own `loading` class in a finally,
             so pending state is tracked here instead. */
          pill.dataset.pending = '1';
          pending = {
            pill: pill,
            timer: setTimeout(function () {
              /* Only fire if this add is still the one in flight. */
              if (!pending || pending.pill !== pill) return;
              pending = null;
              clearPillState(pill);
              msgEl.textContent = "Couldn't add - please try again.";
            }, 4000)
          };
          card.addToCart(v.id, pill);
        });
      }
      pillsWrap.appendChild(pill);
    });
  }

  function open(trigger) {
    if (!sheet) build();
    card = trigger.closest('product-card');
    var data = readCard(card);
    if (!data) return;
    state = data;
    state.colorIndex = findColorIndex(data);
    /* The card element's live option state (set by the vendor at element
       upgrade) wins over the server-rendered default when present. */
    if (card.current_options) state.current = card.current_options.slice();
    /* 6.91: the sheet always opens on the first Print value (Back only, the
       cheaper default) even when the card pictures a Full variant. */
    if (state.printIndex !== null) {
      var prints = distinctValues(state.variants, state.printIndex);
      if (prints.length) state.current[state.printIndex] = prints[0];
    }
    titleEl.textContent = trigger.dataset.quickAddTitle || '';
    msgEl.textContent = '';
    renderColors();
    renderPrints();
    renderSizes();
    sheet.classList.add('active');
    scrim.classList.add('active');
    document.body.classList.add('quick-add-open');
  }

  function onAdded() {
    /* No add of ours in flight - a stale or late event, ignore it. */
    if (!pending) return;
    clearTimeout(pending.timer);
    var pill = pending.pill;
    pending = null;
    delete pill.dataset.pending;
    pill.classList.remove('loading');
    pill.classList.add('added');
    pill.querySelector('span').textContent = 'Added';
    setTimeout(close, 800);
  }

  function close() {
    if (pending) {
      clearTimeout(pending.timer);
      clearPillState(pending.pill);
      pending = null;
    }
    if (!sheet) return;
    sheet.classList.remove('active');
    scrim.classList.remove('active');
    document.body.classList.remove('quick-add-open');
  }

  document.addEventListener('click', function (e) {
    var trigger = e.target.closest('.quick-add-trigger');
    if (!trigger) return;
    e.preventDefault();
    e.stopPropagation();
    open(trigger);
  });

  window.QuickAddSheet = { open: open, close: close };
})();
